/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const MenuItemsContainer = styled.div`
  border-right: 1px solid ${Palette.PrimaryGray._200};
  padding: 8px 8px 8px 8px;
  margin-top: -8px;
  margin-bottom: -8px;
  margin-left: -8px;
  background-color: ${Palette.PrimaryGray._000};
  border-radius: 4px 0 0 4px;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const Title = styled.span`
  display: flex;
  align-items: center;
  gap: 16px;
  white-space: nowrap;
  font-size: 14px;
  svg {
    transform: rotate(-90deg);
    visibility: ${({ isHidden }) => !isHidden && 'hidden'};
  }
`;
export const FilterContentContainer = styled.div`
  display: ${({ isShow }) => (isShow ? 'flex' : 'none')};
  flex-direction: column;
  gap: 2px;
`;
export const Label = styled.span`
  display: flex;
  align-items: center;
  white-space: nowrap;
  gap: 16px;
  svg {
    min-width: 38px;
    fill: ${({ fieldName }) => {
      if (fieldName === 'active') return '#2DB0A9 !important';
      if (fieldName === 'paused') return '#FCAF17 !important';
      if (fieldName === 'suspended') return '#EF4444 !important';
    }};
  }
`;

export const CenteredLoader = styled.div`
  width: 100%;
  min-height: 100%;
  display: grid;
  place-items: center;
`;
export const TargetContainer = styled.div`
  max-height: 450px;
  display: ${({ isShow }) => (isShow ? 'flex' : 'none')};
  flex-direction: column;
  width: 100%;
`;
export const SearchContainer = styled.div`
  min-height: 48px;
  padding: 0 16px;
  border-bottom: 1px solid ${Palette.PrimaryGray._200};
  display: flex;
  align-items: center;
  margin-top: -8px;
  margin-right: -8px;
  border-radius: 0 4px 0 0;
`;
export const CountriesContent = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  ::-webkit-scrollbar {
    max-width: 6px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 8px;
  }
`;
export const CountryItemBox = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 48px;
  padding-left: 16px;
`;
export const Footer = styled.div`
  background-color: ${Palette.PrimaryGray._000};
  border-top: 1px solid ${Palette.PrimaryGray._200};
  display: flex;
  padding-right: 24px;

  gap: 16px;
  min-height: 64px;
  align-items: center;
  margin-right: -8px;
  margin-bottom: -8px;
  border-radius: 0 0 4px 0;
`;
